














































































































import { DetailItem } from "@/store/whatsapp/statistic/types";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import {LongTextWings, ScrollButton} from 'wings-ui-components';
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import WhatsappDetailFilter from "@/components/Whatsapp/WhatsappDetailFilter.vue";
import { dateFilter } from "@/utils/date-util";

@Component({ components: {WhatsappDetailFilter, ScrollButton, LongTextWings}, filters: {dateFilter} })
export default class WhatsappDetail extends BaseItemsPage<DetailItem> {

  @Getter("whatsappStatisticDetail") responseItems: any;

  is_show_filter_additional = false;
  currentSort = "create_date";

  tableFields = this.tableFieldsDefault;

  get tableFieldsDefault() {
    return [
      "create_date",
      "originator",
      "recipient",
      "message",
      "status",
      "partner_price",
      "detail"
    ];
  }

  getData() {
    return this.responseItems;
  }

}
